export default theme => ({
  fileName: {
    display: 'flex',
    marginLeft: 20,
    alignItems: 'center',
    height: '100%',
    '& button, span': {
      fontWeight: 'bold',
      color: theme.colors.primary.black,
      padding: 0,
      '&:hover': {
        color: theme.colors.semantic.info500
      }
    },
    '& svg': {
      width: 18,
      marginRight: 10
    }
  },
  badge: {
    '& span': {
      fontSize: 9
    }
  },
  link: {
    marginLeft: 10
  },
  successFormatter: {
    display: 'flex',
    alignItems: 'center',
    height: '100%',
    marginLeft: 20
  }
});